import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import { UsersService, type TUser } from '@/types/generated'
import { lawFieldsDE, lawFieldsEN, lawFieldsFR } from '@/i18n/lawFields'
import { useLocaleStore } from '@/store/localStore'

export const useUserStore = defineStore('userStore', () => {
  const user = ref<TUser>()
  const localeStore = useLocaleStore()

  const lawFieldOptions = computed(() => {
    const lawFields = user.value?.org.law_fields || []
    const locale = localeStore.locale

    // Get appropriate translations based on locale
    const translations = locale === 'fr' ? lawFieldsFR : locale === 'en' ? lawFieldsEN : lawFieldsDE

    return (lawFields as string[]).map((lawField) => ({
      value: lawField,
      title: translations[lawField] || lawField
    }))
  })

  async function fetchUser() {
    try {
      const response = await UsersService.usersRetrieve({ uuid: 'current' })
      user.value = response
      return response
    } catch (error) {
      console.error('[userStore] fetchUser error:', error)
      return null
    }
  }

  return {
    lawFieldOptions,
    user,
    fetchUser
  }
})
